﻿(function(){
  function labelLogoLink(link){
    var label = link.getAttribute('aria-label') || link.getAttribute('title') || link.textContent.trim();
    var image = link.querySelector('img');
    if (!label && image) label = image.getAttribute('alt') || '';
    if (!label && link.getAttribute('href')) {
      label = link.getAttribute('href').split('/').filter(Boolean).pop() || 'Brand';
      label = label.replace(/-/g, ' ').replace(/all4kids/i, 'All 4 Kids');
      label = label.charAt(0).toUpperCase() + label.slice(1);
    }
    label = label || 'Brand';
    link.setAttribute('aria-label', label);
    link.setAttribute('title', label);
    if (image) image.setAttribute('alt', label);
    if (!link.querySelector('.visually-hidden')) {
      var span = document.createElement('span');
      span.className = 'visually-hidden';
      span.textContent = label;
      link.insertBefore(span, link.firstChild);
    }
  }

  function labelBannerLink(link){
    var label = link.getAttribute('aria-label') || link.getAttribute('title') || '';
    if (!label) {
      var slide = link.closest('.slideshow__slide');
      var source = slide && slide.querySelector('.text-overlay__heading, .subheading, .text-overlay__block, .btn');
      label = source && source.textContent ? source.textContent.trim() : 'Shop slide';
    }
    link.setAttribute('aria-label', label);
    link.setAttribute('title', label);
    var image = link.querySelector('img');
    if (image) image.setAttribute('alt', label);
  }

  function applyFixes(){
    document.querySelectorAll('.logo-list a.block').forEach(labelLogoLink);
    document.querySelectorAll('a.image-banner__image').forEach(labelBannerLink);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', applyFixes);
  else applyFixes();
  window.addEventListener('load', applyFixes);
  setTimeout(applyFixes, 1000);
})();
(function(){
  function fixPoweredBy(){
    document.querySelectorAll('a[href^="https://www.shopify.com?utm_campaign=poweredby"]').forEach(function(link){
      link.setAttribute('aria-label', 'Powered by Shopify');
      link.setAttribute('title', 'Powered by Shopify');
      if (!link.textContent.trim()) link.textContent = 'Powered by Shopify';
      if (!/noopener/.test(link.getAttribute('rel') || '')) link.setAttribute('rel', ((link.getAttribute('rel') || '') + ' noopener').trim());
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', fixPoweredBy);
  else fixPoweredBy();
  window.addEventListener('load', fixPoweredBy);
  setTimeout(fixPoweredBy, 1000);
})();

(function(){
  function applyKlaviyoContrastFix(){
    if (document.getElementById('a11y-klaviyo-contrast-fix')) return;
    var style = document.createElement('style');
    style.id = 'a11y-klaviyo-contrast-fix';
    style.textContent = [
      'form[class*="klaviyo-form"] span,',
      'form[class*="klaviyo-form"] p,',
      'form[class*="klaviyo-form"] label,',
      'form[class*="klaviyo-form"] div[style*="color: rgb(134, 134, 134)"],',
      'form[class*="klaviyo-form"] span[style*="color: rgb(134, 134, 134)"] {',
      '  color: #333333 !important;',
      '}',
      'form[class*="klaviyo-form"] [style*="font-size: 10px"],',
      'form[class*="klaviyo-form"] span[style*="font-size: 10px"] {',
      '  color: #333333 !important;',
      '}',
      'form[class*="klaviyo-form"] input::placeholder {',
      '  color: #555555 !important;',
      '  opacity: 1 !important;',
      '}'
    ].join('\n');
    document.head.appendChild(style);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', applyKlaviyoContrastFix);
  else applyKlaviyoContrastFix();
  window.addEventListener('load', applyKlaviyoContrastFix);
  setTimeout(applyKlaviyoContrastFix, 1000);
  setTimeout(applyKlaviyoContrastFix, 3000);
})();
(function(){
  function fixGoogleMerchantFrame(){
    document.querySelectorAll('iframe#merchantwidgetiframe, iframe[src*="/shopping/merchantverse"]').forEach(function(frame){
      if (!frame.getAttribute('title')) frame.setAttribute('title', 'Google customer reviews widget');
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', fixGoogleMerchantFrame);
  else fixGoogleMerchantFrame();
  window.addEventListener('load', fixGoogleMerchantFrame);
  setTimeout(fixGoogleMerchantFrame, 1000);
  setTimeout(fixGoogleMerchantFrame, 3000);
  setTimeout(fixGoogleMerchantFrame, 6000);

  if (window.MutationObserver) {
    new MutationObserver(fixGoogleMerchantFrame).observe(document.documentElement, {
      childList: true,
      subtree: true
    });
  }
})();
